"use client";

import AdsInManabakh from "@/helpers/svg/adsInManabakh.svg";
import AnnouncmentIcon from "@/helpers/svg/announcmentIcon.svg";
import CallingIcon from "@/helpers/svg/callingIcon.svg";
import ParagraphCircle from "@/helpers/svg/paragraphCircle.svg";
import WhatsappIcon from "@/helpers/svg/whatsappIcon.svg";
import WebpageIcon from "@/helpers/svg/webpageIcon.svg";
import React from "react";
import { useMediaQuery } from "@mui/material";
import AboutUsVector from "@/helpers/svg/aboutUsVector.svg";

const Ads = () => {
  const desktop = useMediaQuery("(min-width:1024px)");

  return (
    <>
      {desktop ? (
        <div className="flex flex-col items-center justify-center h-auto pt-32 play-manabakh relative container mx-auto">
          <div className="w-full flex justify-between px-16">
            <AdsInManabakh />
            <AnnouncmentIcon />
          </div>
          <div className="pt-20 flex flex-col justify-center items-start w-2/3">
            <div className="flex justify-start items-start text-primary-white mb-16">
              <div className="">
                <ParagraphCircle />
              </div>
              <p className="pr-3 text-2xl text-justify">
                منه‌باخ ، رسانه‌ای فراگیر با محتوای حرفه‌ای برای 30 میلیون مخاطب
                تُرک‌زبان و صدها هزار خانواده ایرانی است.
              </p>
            </div>
            <div className="flex justify-center items-start text-primary-white mb-16">
              <div className="">
                <ParagraphCircle />
              </div>
              <p className="pr-3 text-2xl text-justify">
                شمـا می‌توانید ، بـا &quot;هـر سطـح بودجه‌ای&quot; از فرصت‌های
                آگهی &quot;منـه‌بـاخ&quot; برای معرفی کالا و خدمات خود
                استفاده نمایید.
              </p>
            </div>
            <div className="flex justify-center items-start text-primary-white mb-16">
              <div className="">
                <ParagraphCircle />
              </div>
              <p className="pr-3 text-2xl text-justify">
                منه‌باخ برای صاحبان صنایع ، کالا و خدمات فعال در مناطق آذری و
                ایران عزیز امتیازات و تسهیلات ویژه‌ای فراهم نموده است.
              </p>
            </div>
            <div className="flex justify-center items-start text-primary-white mb-16">
              <div className="">
                <ParagraphCircle />
              </div>
              <p className="pr-3 text-2xl text-justify">
                کانون آگهی همراه با 20 سال تجربه در حوزه آگهی در سطوح ملی به
                عنوان مجری انحصاری آگهی‌های پلتفرم منه‌باخ آماده هرگونه همکاری و
                طرّاحی کمپین‌های آگهی ، برای کالا و خدمات شماست.
              </p>
            </div>
            <div className="flex justify-center items-start text-primary-white mb-16">
              <div className="">
                <ParagraphCircle />
              </div>
              <p className="pr-3 text-2xl text-justify">
                تولید و پخش تیزرهای آگهی قبل و بین محتوا / آگهی در انواع
                قالب‌های درون‌برنامه‌ای / تیزر دعوت به تماشا / تیزر حامی برنامه
                / مشارکت در تولید فیلم، سریال و برنامه / تأمین جوایز / مشارکت در
                دوبله / و آگهی‌های مشترک با  منه‌باخ در فضا‌های محیطی و شبکه‌های
                اجتماعی فرصت استثنایی برای معرفی برند و محصولات شما می‌باشد.
              </p>
            </div>
          </div>
          <div className="mx-32 pt-20">
            <p className="text-xl text-[#BFBFBF] text-justify">
              برای دریافت اطلاعات بیشتر و آشنایی با قالب‌ها و تعرفه‌های آگهی
              منه‌باخ از راه‌های زیر اقدام کنید.
            </p>
          </div>
          <div className="flex flex-col md:flex-row h-[40vh] justify-around items-center contact-buttons relative w-[75%] mb-32">
            <div className="flex flex-col justify-center items-center text-primary-white w-[350px] text-xl cursor-pointer">
              <span>صندوق پستی</span>
              <div className="flex flex-row w-full justify-center items-center gr-border bg-[#000000] mt-4">
                <span className="ml-2">ad@manabakh.ir</span>
                <WebpageIcon />
              </div>
            </div>
            <div className="flex flex-col justify-center items-center text-primary-white w-[350px] text-xl cursor-pointer">
              <span>واتس اپ</span>
              <div className="flex flex-row w-full justify-center items-center gr-border bg-[#000000] mt-4">
                <span className="ml-2">09352126666</span>
                <WhatsappIcon />
              </div>
            </div>
            <div className="flex flex-col justify-center items-center text-primary-white w-[350px] text-xl cursor-pointer">
              <span>تماس</span>
              <div className="flex flex-row w-full justify-center items-center gr-border bg-[#000000] mt-4">
                <span className="ml-2">۰۲۱-۲۶۲۱۲۶۸۲</span>
                <CallingIcon />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex flex-col pt-24 px-7 min-h-[100vh] h-auto w-full">
          <div className="flex flex-col justify-center items-center w-full mb-16">
            <div className="flex flex-col justify-center items-center text-[#D9D9D9]">
              <span className="text-3xl font-medium mb-5">تـبلیغات در</span>
              <span className="text-4xl font-bold">مــنـه‌بـاخ</span>
            </div>
            <div className="mb-1 mt-8 px-8 sm:px-0 flex w-full justify-center items-center">
              <AboutUsVector />
            </div>
            <div className="flex justify-around flex-wrap px-8 sm:px-0 sm:flex-nowrap items-center w-full text-[#BFBFBF] mb-14 font-bold text-[12px] sm:text-[18px] xs:text-center">
              <p>
                فرصتی بی‌نظیر برای ارايه کالا و خدمات خود به زبان ترکی و مطابق
                با ذائقه مخاطب آذری
              </p>
            </div>
            <div className="flex flex-col justify-center items-center">
              <div className="bg-[#0F0B0B] rounded-3xl mb-11">
                <div className="flex justify-start items-center text-primary-white text-2xl mb-2 lg:mb-4">
                  <p className="text-base sm:text-xl font-medium text-center pt-2">
                    شما می‌توانید تولیدکننده محتوا در انواع قالب‌های هنری باشید
                    و در ویترین منه‌باخ، پنجره اختصاصی خود را ایجاد کنید.
                  </p>
                </div>
              </div>
              <div className="bg-[#0F0B0B] rounded-3xl mb-11">
                <div className="flex justify-start items-center text-primary-white text-2xl mb-2 lg:mb-4">
                  <p className="text-base sm:text-xl font-medium text-center pt-2">
                    شمـا می‌توانید ، بـا &quot;هـر سطـح بودجه‌ای&quot; از
                    فرصت‌های آگهی &quot;منـه‌بـاخ&quot; برای معرفی کالا و
                    خدمات خود استفاده نمایید.
                  </p>
                </div>
              </div>
              <div className="bg-[#0F0B0B] rounded-3xl mb-11">
                <div className="flex justify-start items-center text-primary-white text-2xl mb-2 lg:mb-4">
                  <p className="text-base sm:text-xl font-medium text-center pt-2">
                    منه‌باخ برای صاحبان صنایع ، کالا و خدمات فعال در مناطق آذری
                    و ایران عزیز امتیازات و تسهیلات ویژه‌ای فراهم نموده است.
                  </p>
                </div>
              </div>
              <div className="bg-[#0F0B0B] rounded-3xl mb-11">
                <div className="flex justify-start items-center text-primary-white text-2xl mb-2 lg:mb-4">
                  <p className="text-base sm:text-xl font-medium text-center pt-2">
                    کانون آگهی همراه با 20 سال تجربه در حوزه آگهی در سطوح ملی به
                    عنوان مجری انحصاری آگهی‌های پلتفرم منه‌باخ آماده هرگونه
                    همکاری و طرّاحی کمپین‌های آگهی ، برای کالا و خدمات
                    شماست.
                  </p>
                </div>
              </div>
              <div className="bg-[#0F0B0B] rounded-3xl">
                <div className="flex justify-start items-center text-primary-white text-2xl">
                  <p className="text-base sm:text-xl font-medium text-center pt-2">
                    تولید و پخش تیزرهای آگهی قبل و بین محتوا / آگهی در
                    انواع قالب‌های درون‌برنامه‌ای / تیزر دعوت به تماشا / تیزر
                    حامی برنامه / مشارکت در تولید فیلم، سریال و برنامه / تأمین
                    جوایز / مشارکت در دوبله / و آگهی‌های مشترک با  منه‌باخ در
                    فضا‌های محیطی و شبکه‌های اجتماعی فرصت استثنایی برای معرفی
                    برند و محصولات شما می‌باشد.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col md:flex-row sm:h-40 h-80 justify-around items-center contact-buttons relative w-full mb-20">
            <div className="flex flex-col justify-center items-center text-primary-white w-[350px] text-xl cursor-pointer mb-6">
              <span>صندوق پستی</span>
              <div className="flex flex-row w-full justify-center items-center gr-border bg-[#000000] mt-4">
                <span className="ml-2">ad@manabakh.ir</span>
                <WebpageIcon />
              </div>
            </div>
            <div className="flex flex-col justify-center items-center text-primary-white w-[350px] text-xl cursor-pointer mb-6">
              <span>واتس اپ</span>
              <div className="flex flex-row w-full justify-center items-center gr-border bg-[#000000] mt-4">
                <span className="ml-2">09352126666</span>
                <WhatsappIcon />
              </div>
            </div>
            <div className="flex flex-col justify-center items-center text-primary-white w-[350px] text-xl cursor-pointer">
              <span>تماس</span>
              <div className="flex flex-row w-full justify-center items-center gr-border bg-[#000000] mt-4">
                <span className="ml-2">۰۲۱-۲۶۲۱۲۶۸۲</span>
                <CallingIcon />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Ads;
